import { RegisterChangeForm } from './apps/register-change/index';
import { CalendarEventListing } from './apps/calendar-event-listing/index';
import { AddCalendarEventForm } from './apps/add-calendar-event/index';
import { Calendar } from './apps/calendar';

const calendars = Array.prototype.slice.call(document.querySelectorAll('[data-tesol-calendar]'));
calendars.forEach((root: HTMLElement) => {
  new Calendar(root);
});

const addCalendarEventForms = Array.prototype.slice.call(document.querySelectorAll('[data-tesol-add-calendar-event]'));
addCalendarEventForms.forEach((root: HTMLElement, index: number) => {
  new AddCalendarEventForm(root, index);
});

const calendarEventListings = Array.prototype.slice.call(
  document.querySelectorAll('[data-tesol-calendar-event-listing]')
);
calendarEventListings.forEach((root: HTMLElement) => {
  new CalendarEventListing(root);
});

const registerChangeForms = Array.prototype.slice.call(document.querySelectorAll('[data-tesol-event-register-change]'));
registerChangeForms.forEach((root: HTMLElement, index: number) => {
  new RegisterChangeForm(root, index);
});